export default __webpack_public_path__ + "static/media/digital-lab-logo.85f0d550.svg";